import React from "react";
import uiPrefix from "../utils/UiPrefixUtils";
import styles from "./DesignViewContainer.module.css";

const DesignViewContainer = ({ children }) => (
  <div className={styles["design-view-container"]} data-e2e={uiPrefix("design-view-container")}>
    {children}
  </div>
);

export default DesignViewContainer;
